"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeZone = exports.formatTime = exports.formatDate = exports.addTime = exports.addDays = void 0;
var string_helpers_1 = require("./string-helpers");
function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
exports.addDays = addDays;
function addTime(date, time) {
    var result = new Date(date);
    result.setTime(result.getTime() + time);
    return result;
}
exports.addTime = addTime;
function formatDate(date, timeZoneOffset) {
    var newDate = addTime(date, -timeZoneOffset * 60 * 1000);
    var dateStr = (0, string_helpers_1.findInString)(newDate.toUTCString(), /(.{3}, \d{1,2} .{3} \d{4,5})/i);
    return dateStr;
}
exports.formatDate = formatDate;
function formatTime(date, timeZoneOffset) {
    var newDate = addTime(date, -timeZoneOffset * 60 * 1000);
    var timeStr = (0, string_helpers_1.findInString)(newDate.toUTCString(), /(\d{1,2}:\d{1,2}:\d{1,2})/i) + " " + formatTimeZone(timeZoneOffset);
    return timeStr;
}
exports.formatTime = formatTime;
function formatTimeZone(timeZoneOffset) {
    var hours = Math.abs(timeZoneOffset / 60.0);
    var sign = '';
    if (timeZoneOffset > 0) {
        sign = '-'; //Do the opposite sign, since the timeZone parameter is represented as minutes difference from UTC
    }
    else {
        sign = '+';
    }
    var extraZero = '';
    if (hours < 10) {
        extraZero = '0';
    }
    return sign + extraZero + hours + ":00";
}
exports.formatTimeZone = formatTimeZone;
// const leadingZero = (num: number) : string => {
//     if(num < 10)
//         return `0${num}`
//     else
//         return `${num}`
// }
// export const getLocalDateTimeString = () => {
//     let dt = DateTime.local();
//     let dateTimeStr = `${leadingZero(dt.month)}/${leadingZero(dt.day)}/${leadingZero(dt.year)} ${leadingZero(dt.hour)}:${leadingZero(dt.minute)} ${dt.offsetNameShort}`;
//     return dateTimeStr;
// }
//# sourceMappingURL=date-time-helpers.js.map